import styled from '@emotion/styled';
import type { ReactNode } from 'react';

import { colorConstants } from 'config/colorConstants';

const StyledSuggestionTile = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 22px;
    padding: 0 10px;
    border-radius: 9999px;
    border: 1px solid ${colorConstants.blueAlt6};
    background: ${colorConstants.lightBlue2};
    color: ${colorConstants.blueAlt3};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    white-space: nowrap;
`;

const StyledSuggestionCell = styled.div`
    display: flex;
    align-items: center;
    min-height: 22px;
`;

export const renderSuggestionTile = (value: unknown): ReactNode => {
    if (typeof value !== 'string' || !value.trim()) {
        return null;
    }

    return (
        <StyledSuggestionCell>
            <StyledSuggestionTile>{value}</StyledSuggestionTile>
        </StyledSuggestionCell>
    );
};
